import Typography from "@mui/material/Typography";

import { CreditsLinkButton } from "@app/analytics/upload/styles";
import ROUTES from "@app/common/routes";
import { pluralizePhrase } from "@app/common/utils";

import { Row } from "@rui/Stack";
import { Bold } from "@rui/styles";

interface CreditsBannerProps {
  onLearnMore: () => void;
  minRemaining: number;
}

const CreditsBanner = ({ onLearnMore, minRemaining }: CreditsBannerProps) => {
  return (
    <Row
      variant="apart"
      spacing={1}
      sx={{
        width: "100%",
        padding: "4px 12px",
        backgroundColor: "shades.ghost.500",
        borderRadius: "4px",
      }}
    >
      <Typography
        variant="bodySecondaryReg"
        sx={{ color: "shades.neutral.600" }}
      >
        {minRemaining < 0 ? (
          <>
            Purchase{" "}
            <Bold>
              {pluralizePhrase(Math.abs(minRemaining), "additional minute")}
            </Bold>{" "}
            to continue.
          </>
        ) : (
          <>
            You have <Bold>{pluralizePhrase(minRemaining, "minute")}</Bold>{" "}
            remaining.
          </>
        )}
      </Typography>
      <Row variant="right" spacing={1}>
        <CreditsLinkButton
          variant="text"
          href={ROUTES.BILLING_CHECKOUT_CREDITS}
        >
          Get more credits
        </CreditsLinkButton>
        <CreditsLinkButton variant="text" onClick={onLearnMore}>
          Learn more
        </CreditsLinkButton>
      </Row>
    </Row>
  );
};

export default CreditsBanner;
